import { ReactNode } from "react";
import { HighlightOptions, INavBarInfo } from "../../component/LeftMenu/NavigationMenu/NavigationPanel";
import { IBreadCrumb } from "../IBreadCrumb";
import { ISideBarProject } from "../../common/api_interfaces/common/ISideBar";
import { IFunctionPermissions } from "../../common/api_interfaces/role/IFunctionPermissions";

export interface IAppContext {
    systemUserAccess: IFunctionPermissions[];
    breadCrumb: IBreadCrumb[];
    setBreadCrumb: React.Dispatch<React.SetStateAction<IBreadCrumb[]>>;
    sideBarProjects: ISideBarProject[];
    navBarInfo: INavBarInfo;
    toggleProject: (id: number) => void;
    toggleBoard: (id: number) => void;
    findBoard: (projects: ISideBarProject[], id: number, archivedPage: boolean) => IBreadCrumb[];
    findProject: (projects: ISideBarProject[], id: number, archivedPage: boolean) => IBreadCrumb[];
    getData: () => Promise<void>;
    navPanelHighlight: HighlightOptions | undefined;
    setNavPanelHighlight: React.Dispatch<React.SetStateAction<HighlightOptions | undefined>>;
    currentZoom: number;
    setCurrentZoom: React.Dispatch<React.SetStateAction<number>>;
    MAX_ZOOM: number;
    MIN_ZOOM: number;
    boardScrollPosition: [number, number] | undefined;
    setBoardScrollPosition: React.Dispatch<React.SetStateAction<[number, number] | undefined>>;
    showToast: (text: string, content?: ReactNode, timeVisible?: number) => void;
    pageTitle: string;
    archivedPage: boolean;
    archivedProjects: ISideBarProject[];
    handleShowLoader: (show: boolean) => void;
    showLoader: boolean,
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}
export const defaultAppContext: IAppContext = {
    systemUserAccess: [],
    breadCrumb: [],
    setBreadCrumb: () => {},
    sideBarProjects: [],
    navBarInfo: {} as INavBarInfo,
    toggleProject: () => {},
    toggleBoard: () => {},
    findBoard: () => [],
    findProject: () => [],
    getData: () => Promise.resolve(),
    navPanelHighlight: undefined,
    setNavPanelHighlight: () => {},
    currentZoom: 1,
    setCurrentZoom: () => {},
    MAX_ZOOM: 1,
    MIN_ZOOM: 0.5,
    boardScrollPosition: undefined,
    setBoardScrollPosition: () => {},
    showToast: () => {},
    pageTitle: 'Task Tracker',
    archivedPage: false,
    archivedProjects: [],
    handleShowLoader: () => {},
    showLoader: false,
    setIsLoading: () => {},
   };
